import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../../entity_staff_element_unified_list_items/fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('entity_staff_element_code'),
	fieldsMap.get('entity_staff_element_description'),
	fieldsMap.get('entity_staff_element_staff_type'),
	fieldsMap.get('note')
];

const config: IFormConfig = { 
	fields: formFields 
};

export default config;
